import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReflectionCards from "../../components/reflectionCards";
import { staticFiles } from "../../components/Helpers/Static";
import { serverUrl, apiUrl } from '../../components/Helpers/Config';
import axios from "axios";
import { FaSearch } from 'react-icons/fa';
import { useHistory, useLocation, useParams, useRouteMatch } from "react-router-dom";
import ButtonBlue from "../../components/Button/ButtonBlue";
import Swal from "sweetalert2";
import { tokenAuthorize } from "../../components/Helpers/Common";

var dropdownOption = [
    { label: "Oldest", value: "asc" },
    { label: "Newest", value: "desc" },
]

function TeachingTask(props) {

    const [filteredPost, setFilteredPost] = useState([])
    const [searchedPost, setSearchedPost] = useState([])
    // const loading = useSelector(state => state.reflections.loading)
    const [hasMore, setHasMore] = useState(true)
    const dispatch = useDispatch();
    const id = props.match.params.id;
    const [searchField, setSearchField] = useState('')
    const [sortField, setSortField] = useState('desc')
    const [loading, setLoading] = useState(false)

    const location = useLocation();
    const history = useHistory();

    const Loading = ({ active }) => {
        let style = active ? "w-10 h-10" : "hidden w-10 h-10";
        return <img src={staticFiles.loading} alt="loading..." className={style} />;
    };

    useEffect(() => {
        const data = {
            sort: sortField,
            offset: 0,
        }
        getTasks(data);
    }, []);

    const getTasks = (data) => {
        setLoading(true)
        let apiurl = apiUrl + 'task/teaching/posts/' + id + "?sort=" + data.sort + "&offset=" + data.offset;
        axios.get(apiurl).then(resp => {
            if (resp.status == 200) {
                if (resp?.data?.posts?.length > 0) {
                    setFilteredPost(resp.data?.posts || [])
                } else {
                    Swal.fire({
                        title: 'Info',
                        text: 'No Data Found'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            goBack()
                        }
                    })
                }
            } else {
                Swal.fire({
                    title: 'Info',
                    text: 'No Data Found'
                }).then((result) => {
                    if (result.isConfirmed) {
                        goBack()
                    }
                })
            }
            setLoading(false)
        }).catch(err => {
            tokenAuthorize(err?.response?.status);
            console.log(err)
            Swal.fire({
                title: 'Error',
                text: 'No Data Found'
            }).then((result) => {
                if (result.isConfirmed) {
                    goBack()
                }
            })
            setLoading(false)
        })
    }

    const onChangeSort = (e) => {
        setSortField(e.target.value)
        const data = {
            sort: e.target.value,
            offset: 0
        }
        getTasks(data);
    }

    const handleChange = (e) => {
        setSearchField(e.target.value)
        let data = [];
        filteredPost.map((t) => (
            t?.fullname?.toLowerCase()?.includes(e.target.value?.toLowerCase()) ? data.push(t) : ""
        ))
        setSearchedPost(data)
    }

    const goBack = () => {
        const prevPage = (location.state && location.state.src) ? location.state.src : '/teaching/detail/';
        const tabId = (location.state && location.state.tabId) ? location.state.tabId : -1;
        history.push(prevPage, { tabId });
    }

    const loadMorePost = () => {
        setLoading(true)
        const offset = filteredPost ? filteredPost.length : 0;
        axios.get(apiUrl + 'task/teaching/posts/' + id + "?sort=" + sortField + "&offset=" + offset)
            .then(resp => {
                if (resp.status === 200) {
                    const feedPosts = resp.data.posts
                    if (feedPosts.length > 0) {
                        feedPosts?.forEach(item => {
                            setFilteredPost(prev => [...prev, item])
                        })
                    }
                    else {
                        setHasMore(false)
                    }
                }
                setLoading(false)
            }).catch(err => {
                tokenAuthorize(err?.response?.status);
                console.log(err)
                setLoading(false)
            })

    }

    return (<>
        <div className="grid lg:flex lg:justify-between my-5 px-5" style={{ marginRight: '16rem', marginLeft: '16rem' }}>
            <div className="flex ml-1 mb-5 lg:mb-0">
                <label onClick={goBack}>
                    <svg className="w-6 h-6 cursor-pointer mt-3" fill="none" stroke="black" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                </label>
            </div>
            <div className="flex flex-col-reverse sm:flex-row">
                <label style={{ paddingTop: '12px' }}>Sort By Date</label>
                <select
                    className="flex flex-row justify-center bg-gray 
                                pl-3 ml-3 pr-3 rounded-lg border-2 text-black"
                    type="text"
                    value={sortField}
                    onChange={onChangeSort}
                >
                    {dropdownOption &&
                        dropdownOption.map((option, index) =>
                            <option key={index} value={option.value}>
                                {option.label}
                            </option>
                        )

                    }
                </select>
                <div className="grid sm:flex ml-3">
                    <div className='flex w-full h-12 rounded-lg overflow-hidden'>
                        <input
                            className='h-full w-full bg-white outline-none px-2 lg:px-3 text-black'
                            type='search'
                            placeholder='Search Student Name...'
                            onChange={handleChange}
                        />
                        <div
                            className='flex items-center justify-center bg-blue text-white h-full w-12 cursor-pointer'
                        >
                            <FaSearch className='w-8 h-8 p-2' />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="mt-5 pt-5 flex flex-col items-center">
            {filteredPost && searchField?.length == 0 &&
                filteredPost.map((item) => (
                    <ReflectionCards
                        item={item}
                        key={item.reflection_id}
                    />
                ))}
            {searchedPost && searchField?.length > 0 &&
                searchedPost.map((item) => (
                    <ReflectionCards
                        item={item}
                        key={item.reflection_id}
                    />
                ))}
        </div>
        <div className="flex flex-col items-center w-full">
            <Loading active={loading} />
            {
                hasMore &&
                <ButtonBlue
                    className="my-4" title="Load more"
                    onClick={loadMorePost}
                />
            }
        </div>
    </>);
}

export default TeachingTask;
